export const useI18nCollection = () => {
    const {locale} = useI18n();
    const pageUri = (uri: string): string => {
        return `/${locale.value}/${uri}`.replace('//', '/');
    }
    const collectionUri = (uri: string): any => {
        return `${uri}_${locale.value}`;
    }
    const getPagePath = (path: string): string => {
        return path.replace(`/${locale.value}`, '');
    }
    return {
        pageUri,
        collectionUri,
        getPagePath
    }
}